import {
  EcommercePerformanceReportNetSalesLastYearAction,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_FAIL,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_SUCCESS,
  LoadEcommercePerformanceReportNetSalesLastYear,
  LoadEcommercePerformanceReportNetSalesLastYearFail,
  LoadEcommercePerformanceReportNetSalesLastYearSuccess
} from "../actions";

export interface IEcommercePerformanceReportNetSalesLastYearEntityState {
  netSalesDataLastYear: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePerformanceReportNetSalesLastYearState {
  entities: { [websiteId: number]: IEcommercePerformanceReportNetSalesLastYearEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePerformanceReportNetSalesLastYearState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePerformanceReportNetSalesLastYearState = initialState, action: EcommercePerformanceReportNetSalesLastYearAction): IEcommercePerformanceReportNetSalesLastYearState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR:
      payload = (<LoadEcommercePerformanceReportNetSalesLastYear>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_SUCCESS:
      payload = (<LoadEcommercePerformanceReportNetSalesLastYearSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            netSalesDataLastYear: payload.netSalesDataLastYear,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_FAIL:
      payload = (<LoadEcommercePerformanceReportNetSalesLastYearFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
